"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndingCallScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
function EndingCallScreen() {
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "40px", color: "white" }) }));
}
exports.EndingCallScreen = EndingCallScreen;
const Container = ui_react_1.styled.span `
    z-index: 3;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;
//# sourceMappingURL=ending_call_screen.js.map